import { DocumentItemViewModel } from "client/Api/Documents/SharePoint/common";
import { useCallback } from "react";
import { openDocument } from "client_legacy/Documents/SharePoint/documentOpener";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { AppType } from "client/Api/Apps/common";
import { localize } from "client_legacy/ndaw/culture";
import { AlertManager, useAlerts } from "client/Hooks";

export type DocumentNavigationHandlerProps = {
	document: DocumentItemViewModel | "unresolved";
}
	& RecentlyOpenedItemConfigurationProps;

export function useDocumentNavigationHandler(props: DocumentNavigationHandlerProps): (() => void) {
	const {
		document
	} = props;

	const alertManager: AlertManager = useAlerts();
	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Documents });

			if (document === "unresolved") {
				alertManager.showError(localize("_ThisItemCantBeOpened"));
				console.error("Unable to convert document result item to document view model.");
				return;
			}
			registerRecentlyOpenedItem(recentlyOpenedItem);

			openDocument(document);
		},
		[
			addAnalyticsAppEvent,
			alertManager,
			document,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}